'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Measurements


// Actions


// Decorators


// Utils


// Constants


var _reactRedux = require('react-redux');

var _reactDnd = require('react-dnd');

var _recompose = require('recompose');

var _lodash = require('lodash');

var _elementConstants = require('../../../common/elements/elementConstants');

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

var _elementDuplicateActions = require('../duplicate/elementDuplicateActions');

var _elementMoveActions = require('../elementMoveActions');

var _selectionActions = require('../selection/selectionActions');

var _draggingActions = require('../../reducers/draggingActions');

var _undoRedoActions = require('../../utils/undoRedo/undoRedoActions');

var _selectedElementsSelector = require('../selection/selectedElementsSelector');

var _elementConnectionsObserverDecorator = require('../../components/connections/components/elementConnectionsObserverDecorator');

var _elementConnectionsObserverDecorator2 = _interopRequireDefault(_elementConnectionsObserverDecorator);

var _elementHelper = require('../../../common/elements/elementHelper');

var _analytics = require('../../analytics');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _connectionsSelector = require('../../components/connections/reducers/connectionsSelector');

var _buildElementOffsetsMap = require('./buildElementOffsetsMap');

var _buildElementOffsetsMap2 = _interopRequireDefault(_buildElementOffsetsMap);

var _buildElementMovesArray = require('./buildElementMovesArray');

var _buildElementMovesArray2 = _interopRequireDefault(_buildElementMovesArray);

var _boardConstants = require('../../../common/boards/boardConstants');

var _dragModifierKeysConstants = require('../../utils/dnd/modifierKeys/dragModifierKeysConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Container Component Methods
 */
var mapConnectionStateToProps = function mapConnectionStateToProps(state) {
    return {
        // FIXME This actually provides no performance benefit because the function is being created every time the
        // state changes.  Need to determine a better way of doing this.
        getConnectingElements: function getConnectingElements(elementId) {
            return (0, _immutableHelper.toIdArray)((0, _connectionsSelector.getConnections)(state).filter(function (connectedElements) {
                return connectedElements.includes(elementId);
            }));
        }
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        startDragging: function startDragging(isSelected, ids) {
            if (!isSelected) {
                dispatch((0, _selectionActions.deselectAllElements)());
            }
            dispatch((0, _draggingActions.dragStart)(ids));
        },
        endDragging: function endDragging() {
            return dispatch((0, _draggingActions.dragEnd)());
        },
        dispatchEndMoveOperation: function dispatchEndMoveOperation() {
            return dispatch((0, _undoRedoActions.endOperation)('move'));
        },
        onDropMove: function onDropMove(_ref) {
            var moves = _ref.moves,
                transactionId = _ref.transactionId;
            return dispatch((0, _elementMoveActions.moveMultipleElements)({ moves: moves, transactionId: transactionId }));
        },
        onDropCopy: function onDropCopy(_ref2) {
            var duplications = _ref2.duplications,
                transactionId = _ref2.transactionId;
            return dispatch((0, _elementDuplicateActions.duplicateMultipleElements)({ duplications: duplications, transactionId: transactionId }));
        },
        dispatchGetSelectedElements: function dispatchGetSelectedElements() {
            return dispatch(function (_, getState) {
                return (0, _selectedElementsSelector.getSelectedElements)(getState());
            });
        },
        dispatchGetSelectedElementIds: function dispatchGetSelectedElementIds() {
            return dispatch(function (_, getState) {
                return (0, _selectedElementsSelector.getSelectedElementIds)(getState());
            });
        }
    };
};

var mapMeasurementsDispatchToProps = function mapMeasurementsDispatchToProps(dispatch) {
    return {
        dispatchGetMeasurementsMap: function dispatchGetMeasurementsMap() {
            return dispatch(function (_, getState) {
                return (0, _measurementsSelector.getMeasurementsMap)(getState());
            });
        }
    };
};

var trackDraggingAnalyticsEvent = function trackDraggingAnalyticsEvent(copyDrag, dropResult, _ref3) {
    var element = _ref3.element,
        inList = _ref3.inList;

    if (copyDrag) return (0, _analytics.analyticsEvent)('duplicated-element-opt-drag');
    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.TRASH) return (0, _analytics.analyticsEvent)('moved-element-to-trash-drag');
    if (dropResult.location.section === _boardConstants.BOARD_SECTIONS.INBOX && dropResult.location.parentId === element.getIn(['location', 'parentId']) && inList !== 'in-list') {
        return (0, _analytics.analyticsEvent)('moved-element-to-unsorted-notes');
    }
};

var getDraggedElements = function getDraggedElements(element, selectedElementIds, selectedElements) {
    // ID of the element that's actually being dragged (from react-dnd perspective)
    var grabbedElementId = element.get('id');
    var draggedElements = null;

    if (selectedElementIds.size && selectedElementIds.includes(grabbedElementId)) {
        draggedElements = selectedElements.filter((0, _lodash.negate)(_elementHelper.isElementLocked)).toArray();
    } else {
        draggedElements = [element];
    }

    return (0, _elementHelper.filterOutLinkedBoards)(draggedElements);
};

/**
 * Drag source contract.
 */
var draggableElementSource = {
    canDrag: function canDrag(_ref4) {
        var isEditing = _ref4.isEditing,
            isEditingChild = _ref4.isEditingChild,
            isEditable = _ref4.isEditable,
            isLocked = _ref4.isLocked;

        return !isLocked && isEditable && !(isEditing || isEditingChild);
    },


    // Returns the data describing the dragged tool
    beginDrag: function beginDrag(props, monitor, component) {
        var element = props.element,
            startDragging = props.startDragging,
            isSelected = props.isSelected,
            getConnectingElements = props.getConnectingElements,
            dispatchGetSelectedElementIds = props.dispatchGetSelectedElementIds,
            dispatchGetSelectedElements = props.dispatchGetSelectedElements,
            dispatchGetMeasurementsMap = props.dispatchGetMeasurementsMap,
            gridSize = props.gridSize;

        // Find out the offsets (from the top left of the grabbed element) for all dragged elements

        var selectedElementIds = dispatchGetSelectedElementIds();
        var selectedElements = dispatchGetSelectedElements();
        var draggedElements = getDraggedElements(element, selectedElementIds, selectedElements);
        var draggedElementIds = draggedElements.map(function (el) {
            return el.get('id');
        });
        var connectingElementIds = (0, _lodash.uniq)((0, _lodash.flatMap)(draggedElementIds, getConnectingElements));
        var location = element.get('location').toJS();

        startDragging(isSelected, draggedElementIds);

        var measurementsMap = dispatchGetMeasurementsMap();
        var offsetsMap = (0, _buildElementOffsetsMap2.default)({
            grabbedElement: element,
            draggedElements: draggedElements,
            measurementsMap: measurementsMap,
            gridSize: gridSize
        });

        return {
            element: element,
            connectingElementIds: connectingElementIds,
            draggedElementIds: draggedElementIds,
            draggedElements: draggedElements,
            offsetsMap: offsetsMap,
            originalLocation: location,
            fromList: !!props.inList,
            hoveredItems: {},
            hoveredTypes: {}
        };
    },
    isDragging: function isDragging(props, monitor) {
        var element = props.element;

        var thisElementId = element.get('id');
        var item = monitor.getItem();
        var draggedElementIds = item.draggedElementIds,
            connectingElementIds = item.connectingElementIds;

        return draggedElementIds.includes(thisElementId) || (0, _lodash.includes)(connectingElementIds, thisElementId);
    },


    // Handles when the tool is dropped
    endDrag: function endDrag(props, monitor, component) {
        var element = props.element,
            endDragging = props.endDragging,
            onDropMove = props.onDropMove,
            onDropCopy = props.onDropCopy,
            dragModifierKeys = props.dragModifierKeys,
            gridSize = props.gridSize,
            dispatchGetSelectedElementIds = props.dispatchGetSelectedElementIds,
            dispatchEndMoveOperation = props.dispatchEndMoveOperation,
            dispatchGetMeasurementsMap = props.dispatchGetMeasurementsMap,
            dispatchGetSelectedElements = props.dispatchGetSelectedElements;


        endDragging();
        var operationTransactionId = dispatchEndMoveOperation();

        // Doing nothing if it was not dropped onto a compatible target
        if (!monitor.didDrop()) return;

        var item = monitor.getItem();
        var dropResult = monitor.getDropResult();
        var copyDrag = dragModifierKeys.get(_dragModifierKeysConstants.MODIFIER_KEYS.altKey);

        // Only drop if a location is returned by the drop target
        if (!dropResult.location) return;

        trackDraggingAnalyticsEvent(copyDrag, dropResult, props);

        // Use the drop transaction ID if one exists, otherwise use the move transaction ID
        var transactionId = dropResult.transactionId || operationTransactionId;

        var measurementsMap = dispatchGetMeasurementsMap();
        var moves = (0, _buildElementMovesArray2.default)({ element: element, dropResult: dropResult, item: item, gridSize: gridSize, measurementsMap: measurementsMap });

        if (copyDrag) {
            // Update the IDs of aliases that we're duplicating to their physical board
            var selectedElements = dispatchGetSelectedElements();
            var selectedElementIds = dispatchGetSelectedElementIds();
            var draggedAliases = getDraggedElements(element, selectedElementIds, selectedElements).filter(_elementHelper.isAlias);

            var duplications = moves.map(function (move) {
                var alias = (0, _lodash.find)(draggedAliases, function (aliasEl) {
                    return aliasEl.get('id') === move.id;
                });
                if (!alias) return move;

                return _extends({}, move, {
                    id: (0, _elementHelper.getPhysicalId)(alias)
                });
            });

            return onDropCopy({
                duplications: duplications,
                transactionId: transactionId
            });
        }

        onDropMove({ moves: moves, transactionId: transactionId });
    }
};

var dragCollect = function dragCollect(connector, monitor) {
    return {
        // Call inside render() to let React handle the drag event
        connectDragSource: connector.dragSource(),
        connectDragPreview: connector.dragPreview(),
        // Get current drag state from the monitor
        isDragging: monitor.isDragging()
    };
};

exports.default = function (Element) {
    return (0, _recompose.compose)((0, _elementConnectionsObserverDecorator2.default)(mapConnectionStateToProps), (0, _reactRedux.connect)(null, mapDispatchToProps), (0, _measurementsConnect2.default)(null, mapMeasurementsDispatchToProps), (0, _reactDnd.DragSource)(_elementConstants.ELEMENT_DND_TYPE, draggableElementSource, dragCollect))(Element);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/DraggableElement.js
// module id = 1966
// module chunks = 0